/**
 * Replaces {{Variable}} placeholders in a referral custom_message.
 *
 * Supported variables:
 *  {{ReferralLink}}  – the full sharable URL
 *  {{ReferralCode}}  – the code portion of the URL (?code=xxx)
 *  {{RewardValue}}   – e.g. "50 points" or "10% off"
 *  {{ExpiryDate}}    – formatted expiry date of the referral program
 */
export interface ReferralMessageVars {
  ReferralLink?: string;
  ReferralCode?: string;
  RewardValue?: string;
  ExpiryDate?: string;
}

export function interpolateReferralMessage(
  template: string,
  vars: ReferralMessageVars
): string {
  return template.replace(/\{\{(\w+)\}\}/g, (match, key: string) => {
    return vars[key as keyof ReferralMessageVars] ?? match;
  });
}

/** Extract referral code from a referral link URL (query param `code`). */
export function extractReferralCode(referralLink: string): string | undefined {
  try {
    return new URL(referralLink).searchParams.get('code') ?? undefined;
  } catch {
    return undefined;
  }
}

/** Format an ISO date string to a human-readable short date, e.g. "28 Feb 2026". */
export function formatExpiryDate(isoDate?: string | null): string | undefined {
  if (!isoDate) return undefined;
  try {
    return new Date(isoDate).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return undefined;
  }
}
